import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Row, Card, Descriptions, message, Typography, Tooltip, Skeleton, Tag } from "antd";
import { ApiFilled, InfoCircleFilled, DiffFilled } from '@ant-design/icons';

import { getDependencyByCode } from "../../API/dependencies";
import BackButton from "../Common/BackButton/BackButton";
import BreadCrumb from "../Common/BreadCrumb/BreadCrumb";
import PageTitle from "../Common/PageTitle/PageTitle";
import ChangeLog from "../Common/ChangeLog/ChangeLog";
import Assetia from '../Common/Assetia/Assetia';

import './DependenciesDetail.css';

const { Title, Text } = Typography;

const DependenciesDetail = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [dependency, setDependency] = useState(null);

  useEffect(() => {
    const fetchDependency = async () => {
      try {
        const data = await getDependencyByCode(code);
        setDependency(data);
      } catch (error) {
        message.error("No se encontró la dependencia.");
      }
    };

    fetchDependency();
  }, [code]);

  const breadCrumbUrl = [
    { label: "Dependencias", url: "/dependencies" },
    { label: dependency ? `${dependency.name}` : "Cargando..." },
  ];

  const goToBioFunctions = () => {
    navigate(-1);
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <PageTitle title="Detalle de Dependencias" icon="dependencies" />
        </Col>
      </Row>

      <Row justify="start" align="middle" gutter={16} style={{ marginBottom: 20 }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <BackButton onConfirm={goToBioFunctions} />
          <BreadCrumb location={breadCrumbUrl} activeKey={code} />
        </Col>
      </Row>
    {
      !dependency ? (
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
        <div style={{ height: 32 }} />
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
        </Row>
      </>
      ) : (
      <>
        <Row gutter={[16, 16]} justify="center">
          {/* Card de Información General */}
          <Col xs={24} md={24}>
            <Card hoverable className="detail-card" style={{ position: 'relative' }}>
              <div div className="card-content">
                {/* <InfoCircleFilled className="icon-large icon-custom" /> */}
                  <div className="text-content">
                    <Title className="title-custom" level={4} style={{ marginBottom: 16 }}>Dependencia</Title>
                    <div style={{ position: 'absolute', top: 24, right: 24 }}>
                      <ChangeLog data={dependency} logs={dependency?.logs || []} />
                    </div>
                    
                    {dependency ? (
                      <Descriptions bordered column={1} size="middle">
                        <Descriptions.Item label="Nombre">
                          <Text strong>{dependency.name}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Descripción">
                          {dependency.description || "No disponible"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tipo">
                          {dependency.type?.name || "No disponible"}
                        </Descriptions.Item>
                      </Descriptions>
                    ) : (
                      <Text type="secondary">Cargando detalles...</Text>
                    )}
                  </div>
              </div>
            </Card>
          </Col>

          {/* Card de Activo Relacionado */}
          <Col xs={12} md={12}>
            <Card hoverable className="detail-card">
              <div className="card-content">
                {/* <ApiFilled className="icon-large icon-custom" /> */}
                <div className="text-content">
                  <Title className="title-custom" level={4}>Activo Relacionado</Title>
                  
                  {dependency?.asset ? (
                    <Descriptions bordered column={1} size="middle">
                      <Descriptions.Item label="Nombre">
                        <Text strong>{dependency.asset.name}</Text>
                      </Descriptions.Item>
                      {dependency.asset.description && (
                        <Descriptions.Item label="Descripción">{dependency.asset.description}</Descriptions.Item>
                      )}
                    </Descriptions>
                  ) : (
                    <Text type="secondary">No disponible</Text>
                  )}
                </div>
              </div>
            </Card>
          </Col>

          {/* Card de Atributos */}
          <Col xs={12} md={12}>
            <Card hoverable className="detail-card">
              <div className="card-content">
                {/* <DiffFilled className="icon-large icon-custom" /> */}
                <div className="text-content">
                  <Title className="title-custom" level={4}>Atributos</Title>

                  {dependency?.atributes?.length > 0 ? (
                    <Descriptions bordered column={1} size="middle">
                      {dependency.atributes.map((attr, index) => {
                        if (!attr.atribute) return null;

                        return (
                          <Descriptions.Item key={index} label={attr.atribute.key}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <Tooltip title={attr.value}>
                                <Tag>{attr.value}</Tag>
                              </Tooltip>
                              {attr.log && (
                                <ChangeLog data={attr} logs={attr.log || []} />
                              )}
                            </div>
                          </Descriptions.Item>
                        );
                      })}
                    </Descriptions>
                  ) : (
                    <Text type="secondary">No tiene atributos</Text>
                  )}
                </div>
              </div>
            </Card>
          </Col>

        </Row>

        <Row style={{ marginTop: 80 }}>
          <Assetia
            pageTitle="detalle de dependencias"
            pageDescription="ver en detalle la información de tu dependencia"
            view="dependencies"
          />
        </Row>
      </>
      )
    }
    </>
  );
};

export default DependenciesDetail;